import { render } from "./main-product-sidebar-header.vue?vue&type=template&id=39ff7a88"
import script from "./main-product-sidebar-header.vue?vue&type=script&lang=js"
export * from "./main-product-sidebar-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__